import styled from 'styled-components';

import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const AccountNavbarStyle = styled.div`
  .skeleton-navbar {
    width: ${toRem(280)};
    height: ${toRem(36)};

    @media ${baseVariables.mediaQuery.desktop} {
      height: ${toRem(44)};
    }
  }
`;
